/* eslint-disable @typescript-eslint/no-explicit-any */
import { logger } from './logger';

// Valid perf categories && its matching names
interface PerfAttendee {
  type: 'attendee';
  name: 'join.button' | 'join.webinar';
}
interface PerfApi {
  type: 'api';
  name: 'queryPublicSet' | 'queryOther';
}
interface PerfVideo {
  type: 'video';
  name: 'buffer.duration' | 'timeToInitialLoad';
}

export type ValidPerfCategories = PerfAttendee | PerfApi | PerfVideo;

export type EventPerfDetails = {
  type: ValidPerfCategories['type'];
  name: ValidPerfCategories['name'];
  timestampStart?: number;
  timestampEnd?: number;
  durationMs?: number;
} & Record<string, any>;

// You must declare the correct event type, and 'name' for our logger
export function eventPerfStart({ type, name }: EventPerfDetails): EventPerfDetails {
  const timestampStart = Date.now();
  return {
    type,
    name,
    timestampStart,
  };
}

// Receives perfDetails object & appends new fields, timestampEnd & durationMs
export function eventPerfEnd(perfDetailsStart: EventPerfDetails): void {
  const timestampEnd = Date.now();
  const perfDetailsEnd: EventPerfDetails = {
    ...perfDetailsStart,
    timestampEnd,
    durationMs: timestampEnd - perfDetailsStart.timestampStart!,
  };

  // Logs to CloudWatch with total duration between events
  logger.perf(perfDetailsEnd);
}
